/**
 * Checks if url has gated=false param, opens gate if so
 * @returns {boolean} true if URL has false param
 */
export default function hasGatedFalseURLParam() {
    const { search } = window.location;
    const hashes = search.slice(search.indexOf("?") + 1).split("&");
    // if returns true of gated=false is present
    return hashes.includes("gated=false");
}
